import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

let messagingInstance = null;

const getMessagingSafe = async () => {
  if (messagingInstance) return messagingInstance;
  if (typeof window === "undefined") return null;
  const supported = await isSupported();
  if (!supported) return null;
  messagingInstance = getMessaging(app);
  return messagingInstance;
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;
    const messaging = await getMessagingSafe();
    if (!messaging) return;
    // Register FCM service worker so the push subscription is on the worker that handles background messages
    const swPath = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js?v=2`;
    const reg = await navigator.serviceWorker.register(swPath, { updateViaCache: "none" });
    await reg.update();
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: reg,
    });
    if (token) {
      await axios.patch(`/store-fcm-token`, { fcmToken: token });
    }
  } catch (error) {
    console.warn("FCM: Error getting or storing token", error?.message || error);
  }
};

/**
 * Sets up the foreground FCM message listener. Call once when the app is open
 * and notifications are allowed. Invokes callback for each message received.
 * Returns a Promise that resolves to an unsubscribe function (call it in effect cleanup to avoid duplicate listeners).
 */
export const onMessageListener = (callback) => {
  return getMessagingSafe().then((messaging) => {
    if (!messaging || typeof callback !== "function") return () => {};
    return onMessage(messaging, callback);
  });
};
